import React from "react";
import Box from "@mui/material/Box";

/**
 * The little bordered pills used for technologies and skills.
 * Previously inlined (with its own colour ternaries) in five different files.
 */
const TagList = ({ tags = [], size = "medium", justify = "flex-start", sx }) => {
  if (!tags.length) return null;

  return (
    <Box
      component="ul"
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 1,
        listStyle: "none",
        p: 0,
        m: 0,
        justifyContent: justify,
        ...sx,
      }}
    >
      {tags.map((tag) => (
        <Box
          component="li"
          key={tag}
          sx={(theme) => ({
            fontSize: size === "small" ? "0.75rem" : "0.8rem",
            lineHeight: 1.6,
            px: 0.75,
            py: 0.25,
            borderRadius: "7px",
            border: theme.tokens.tag.border,
            color: theme.tokens.tag.color,
            backgroundColor: theme.tokens.tag.background,
            transition: "border-color 0.2s ease",
            "&:hover": { borderColor: theme.tokens.tag.hoverBorderColor },
          })}
        >
          {tag}
        </Box>
      ))}
    </Box>
  );
};

export default TagList;
